import returnAppConfig from '@/helpers/return-app-config';



function returnExternalHosts() {
  const { environment } = returnAppConfig();

  const hosts = {
    demo: { selfService: 'https://demo-account.cardfree.net' },
    dev: { selfService: 'https://dev-account.cardfree.net' },
    local: { selfService: 'https://dev-account.cardfree.net' },
    uat: { selfService: 'https://uat-account.cardfree.net' },
    stage: { selfService: 'https://stage-account.cardfree.com' },
    prod: { selfService: 'https://account.cardfree.com' }
  };

  return hosts[environment];
}



export default returnExternalHosts;
